import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import { ActionCreators } from "../actions";
import SoonestSlotsProvidersDialog from "./SoonestSlotsProvidersDialog";

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

function SoonestSlotsProviders(props) {
  const [state, setState] = useState({
    open: false,
    distance: "n/a"
  });

  useEffect(
    () => {
      if (props.data !== state.test) {
        setState({
          data: props.data,
          DATA_fetch_providers: props.DATA_fetch_providers,
          DATA_fetch_locations: props.DATA_fetch_locations
        });
      }
    },
    [props.data]
  );

  const handleClose = () => {
    setState(prevState => ({ ...prevState, open: false }));
  };

  const handleSort = e => {
    e.preventDefault();
    e.persist();
    setState(prevState => ({
      ...prevState,
      open: true,
      selectedSlotData: {
        providerImage: e.currentTarget.getAttribute("data-provider-image"),
        locationAddress: e.currentTarget.getAttribute("data-location-address"),

        onehour: e.currentTarget.getAttribute("data-onehour") === "true",
        appointment: e.currentTarget.getAttribute("data-appointment"),

        durationEnd: e.currentTarget.getAttribute("data-duration-end"),
        durationStart: e.currentTarget.getAttribute("data-duration-start"),
        timestampEnd: e.currentTarget.getAttribute("data-timestamp-end"),
        timestampStart: e.currentTarget.getAttribute("data-timestamp-start"),

        slotkey: e.currentTarget.getAttribute("data-slotkey"),

        locationID: e.currentTarget.getAttribute("data-location-id"),
        locationName: e.currentTarget.getAttribute("data-location-name"),
        providerID: e.currentTarget.getAttribute("data-provider-id"),
        providerName: e.currentTarget.getAttribute("data-provider-name")
      }
    }));
  };

  const deg2rad = deg => deg * (Math.PI / 180);

  const getDistanceFromLatLonInMiles = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;
    const m = d * 0.62137;
    const miles = parseFloat(m.toFixed(1));

    return miles;
  };

  return (
    <div>
      {props.slotLength === 0 && (
        <div className="noAppointmentsTxt">
          Sorry, there are no appointment slots available.
        </div>
      )}
      {state.data &&
        state.DATA_fetch_providers &&
        state.DATA_fetch_locations && (
          <div>
            {Object.keys(state.data).map(provIndex => (
              <div key={provIndex} className="soonerTimeslots">
                <div className="locationMiniInfo">
                  <div className="slotContainer">
                    {Object.keys(state.data[provIndex]).map(cat => {
                      if (state.data[provIndex][cat].length !== 0) {
                        return (
                          <div
                            key={`slotKey-${cat}`}
                            style={{ width: "92%", margin: "0 auto" }}
                          >
                            <h1>
                              {props.locations[cat].name}
                              <div>
                                {!props.coordsDisabled ? (
                                  <div>
                                    {props.dataGeoLocations.coordsEnabled && (
                                      <span>
                                        {getDistanceFromLatLonInMiles(
                                          props.locations[cat].coordinates.lat,
                                          props.locations[cat].coordinates.long,
                                          props.dataGeoLocations
                                            .coordLatitudeUser,
                                          props.dataGeoLocations
                                            .coordLongitudeUser
                                        )}
                                        miles away
                                      </span>
                                    )}
                                  </div>
                                ) : null}
                              </div>
                            </h1>
                            <div className="slotContainerInner">
                              {state.data[provIndex][cat].length !== 0 &&
                                state.data[provIndex][cat].map((i, index) => {
                                  if (i.appointment === false) {
                                    const diffTimeStart =
                                      i.durationTimestamp.start;
                                    const diffTimeEnd = i.durationTimestamp.end;
                                    const diffTime =
                                      diffTimeEnd - diffTimeStart;

                                    return (
                                      <div
                                        key={`slotBuggleKey-${index}`}
                                        className={`soonerTimeslotsOuter ${
                                          diffTime === 1800000
                                            ? "halfHour"
                                            : "fullHour"
                                        }`}
                                      >
                                        {!i.appointment && (
                                          <div className="soonerTimeslotsInner">
                                            {props.oneHourAppointments &&
                                              diffTime === 1800000 && (
                                                <Button
                                                  data-location-address={
                                                    props.DATA_fetch_locations[
                                                      i.location
                                                    ].address
                                                  }
                                                  data-provider-image={
                                                    props.DATA_fetch_providers[
                                                      i.provider
                                                    ].fileURL
                                                  }
                                                  data-onehour={
                                                    props.oneHourAppointments
                                                  }
                                                  data-appointment={Object.values(
                                                    i.appointment
                                                  )}
                                                  data-duration-end={
                                                    i.duration.end
                                                  }
                                                  data-duration-start={
                                                    i.duration.start
                                                  }
                                                  data-timestamp-end={
                                                    i.durationTimestamp.end
                                                  }
                                                  data-timestamp-start={
                                                    i.durationTimestamp.start
                                                  }
                                                  data-slotkey={i.key}
                                                  data-location-id={i.location}
                                                  data-location-name={
                                                    state.DATA_fetch_locations[
                                                      i.location
                                                    ].name
                                                  }
                                                  data-provider-id={i.provider}
                                                  data-provider-name={
                                                    i.providerName
                                                  }
                                                  onClick={handleSort}
                                                  disabled
                                                >
                                                  <div>
                                                    {moment(
                                                      i.duration.start
                                                    ).format("hh:mm")}
                                                    <span>
                                                      {moment(
                                                        i.duration.start
                                                      ).format("A")}
                                                    </span>
                                                  </div>
                                                </Button>
                                              )}
                                            {!props.oneHourAppointments &&
                                              diffTime === 1800000 && (
                                                <Button
                                                  data-location-address={
                                                    props.DATA_fetch_locations[
                                                      i.location
                                                    ].address
                                                  }
                                                  data-provider-image={
                                                    props.DATA_fetch_providers[
                                                      i.provider
                                                    ].fileURL
                                                  }
                                                  data-onehour={
                                                    props.oneHourAppointments
                                                  }
                                                  data-appointment={Object.values(
                                                    i.appointment
                                                  )}
                                                  data-duration-end={
                                                    i.duration.end
                                                  }
                                                  data-duration-start={
                                                    i.duration.start
                                                  }
                                                  data-timestamp-end={
                                                    i.durationTimestamp.end
                                                  }
                                                  data-timestamp-start={
                                                    i.durationTimestamp.start
                                                  }
                                                  data-slotkey={i.key}
                                                  data-location-id={i.location}
                                                  data-location-name={
                                                    state.DATA_fetch_locations[
                                                      i.location
                                                    ].name
                                                  }
                                                  data-provider-id={i.provider}
                                                  data-provider-name={
                                                    i.providerName
                                                  }
                                                  onClick={handleSort}
                                                >
                                                  {/* {i.providerName} */}
                                                  <div>
                                                    {moment(
                                                      i.duration.start
                                                    ).format("hh:mm")}
                                                    <span>
                                                      {moment(
                                                        i.duration.start
                                                      ).format("A")}
                                                    </span>
                                                  </div>
                                                </Button>
                                              )}
                                            {// onehour active and if its fullhour slot
                                            props.oneHourAppointments &&
                                              diffTime === 3600000 && (
                                                <Button
                                                  data-location-address={
                                                    props.DATA_fetch_locations[
                                                      i.location
                                                    ].address
                                                  }
                                                  data-provider-image={
                                                    props.DATA_fetch_providers[
                                                      i.provider
                                                    ].fileURL
                                                  }
                                                  data-onehour={
                                                    props.oneHourAppointments
                                                  }
                                                  data-appointment={Object.values(
                                                    i.appointment
                                                  )}
                                                  data-duration-end={
                                                    i.duration.end
                                                  }
                                                  data-duration-start={
                                                    i.duration.start
                                                  }
                                                  data-timestamp-end={
                                                    i.durationTimestamp.end
                                                  }
                                                  data-timestamp-start={
                                                    i.durationTimestamp.start
                                                  }
                                                  data-slotkey={i.key}
                                                  data-location-id={i.location}
                                                  data-location-name={
                                                    state.DATA_fetch_locations[
                                                      i.location
                                                    ].name
                                                  }
                                                  data-provider-id={i.provider}
                                                  data-provider-name={
                                                    i.providerName
                                                  }
                                                  onClick={handleSort}
                                                >
                                                  {/* {i.providerName} */}
                                                  <div>
                                                    {moment(
                                                      i.duration.start
                                                    ).format("hh:mm")}
                                                    <span>
                                                      {moment(
                                                        i.duration.start
                                                      ).format("A")}
                                                    </span>
                                                  </div>
                                                </Button>
                                              )}
                                            {!props.oneHourAppointments &&
                                              diffTime === 3600000 && (
                                                <Button
                                                  data-location-address={
                                                    props.DATA_fetch_locations[
                                                      i.location
                                                    ].address
                                                  }
                                                  data-provider-image={
                                                    props.DATA_fetch_providers[
                                                      i.provider
                                                    ].fileURL
                                                  }
                                                  data-onehour={
                                                    props.oneHourAppointments
                                                  }
                                                  data-appointment={Object.values(
                                                    i.appointment
                                                  )}
                                                  data-duration-end={
                                                    i.duration.end
                                                  }
                                                  data-duration-start={
                                                    i.duration.start
                                                  }
                                                  data-timestamp-end={
                                                    i.durationTimestamp.end
                                                  }
                                                  data-timestamp-start={
                                                    i.durationTimestamp.start
                                                  }
                                                  data-slotkey={i.key}
                                                  data-location-id={i.location}
                                                  data-location-name={
                                                    state.DATA_fetch_locations[
                                                      i.location
                                                    ].name
                                                  }
                                                  data-provider-id={i.provider}
                                                  data-provider-name={
                                                    i.providerName
                                                  }
                                                  onClick={handleSort}
                                                  disabled
                                                >
                                                  {/* {i.providerName} */}
                                                  <div>
                                                    {moment(
                                                      i.duration.start
                                                    ).format("hh:mm")}
                                                    <span>
                                                      {moment(
                                                        i.duration.start
                                                      ).format("A")}
                                                    </span>
                                                  </div>
                                                </Button>
                                              )}
                                          </div>
                                        )}
                                      </div>
                                    );
                                  }

                                  return <Fragment />;
                                })}
                            </div>
                          </div>
                        );
                      }

                      return <Fragment />;
                    })}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      {state.selectedSlotData ? (
        <Dialog
          fullScreen
          open={state.open}
          onClose={handleClose}
          TransitionComponent={Transition}
          className="scheduleDialog"
        >
          <SoonestSlotsProvidersDialog
            selectedSlotData={state.selectedSlotData}
            onClose={handleClose}
          />
        </Dialog>
      ) : null}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    dataGeoLocations: state.dataGeoLocations
  };
}

// for redux dispatch
function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

// for redux
export default connect(mapStateToProps, mapDispatchToProps)(
  SoonestSlotsProviders
);
